/**
 * Utility to force passive event listeners for scroll performance
 * Fixes the "[Violation] Added non-passive event listener" warnings
 */

export const setupPassiveEvents = (): void => {
  // Detect if passive is supported
  let supportsPassive = false
  try {
    // Test via a getter in the options object to see if the passive property is accessed
    const opts = Object.defineProperty({}, 'passive', {
      get: function () {
        supportsPassive = true
        return true
      },
    })
    // Use an event that's guaranteed to exist for testing
    window.addEventListener('testPassive', null as any, opts)
    window.removeEventListener('testPassive', null as any, opts)
  } catch (e) {
    // If an error occurs, passive is not supported
  }

  // If passive is not supported, no need to proceed
  if (!supportsPassive) return

  // Monkey patch addEventListener to make these events passive by default
  const originalAddEventListener = EventTarget.prototype.addEventListener
  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    // These are the events that should be passive by default
    const passiveEvents = ['touchstart', 'touchmove', 'mousewheel', 'wheel']

    // If it's one of our target events, and options doesn't explicitly set passive to false
    if (passiveEvents.includes(type)) {
      // Handle both forms of the options parameter
      if (typeof options === 'object' && options !== null) {
        if (options.passive === undefined) {
          options = { ...options, passive: true }
        }
      } else if (options === undefined || options === false) {
        options = { passive: true }
      }
    }

    // Call the original with our potentially modified options
    return originalAddEventListener.call(this, type, listener, options)
  }

  // console.log('Passive event listeners are now used by default for scroll/touch events')
}
